import React, { useMemo } from 'react'
import { RadioChangeEvent } from 'antd/lib/radio'

import { useT } from 'src/core/hooks/use-translation'

import { WrapButtons, WrapContainer } from './styles'

interface Props {
  defaultValue?: keyof Segments<string>
  onChange?(e: RadioChangeEvent): void
  segments: Segments<string>
  value?: keyof Segments<string>
}

interface Segment {
  disabled: boolean
  title: string
  renderContent(): React.ReactNode
}

export type Segments<Types extends string> = {
  [k in Types]?: Segment
}

function SegmentControl({ defaultValue, onChange, segments, value }: Props) {
  const { t } = useT()
  const segmentKeys = useMemo<(keyof Segments<string>)[]>(() => {
    return Object.keys(segments)
  }, [segments])

  if (segmentKeys && segmentKeys.length <= 1) {
    return <span />
  }

  return (
    <WrapContainer
      buttonStyle="solid"
      defaultValue={defaultValue}
      onChange={onChange}
      value={value}
    >
      {segmentKeys.map((segmentKey, index) => (
        <WrapButtons
          data-test-id={`segment-${index}-${segmentKey}`}
          disabled={segments[segmentKey].disabled}
          key={segmentKey}
          value={segmentKey}
        >
          {t(segments[segmentKey].title)}
        </WrapButtons>
      ))}
    </WrapContainer>
  )
}

export default SegmentControl
